export const SET_CATEGORIES = "SET_CATEGORIES"